import React, { Component } from 'react';

import styles from "./Loading.module.scss";

export default class Loading extends Component {
    render() {
        return (
            <div className={styles.loading}>
                <div>
                    <img src={require('images/animated/loading.svg')} alt={""} />
                    <p>Loading...</p>
                </div>
            </div>
        );
    }
}